import { Directive, ElementRef, HostListener } from '@angular/core';
 
@Directive({
  selector: '[TwoDigitfloatValue]'
})
export class TwoDigitfloatValueDirective {
  // Allow decimal numbers and negative values
  private regex: RegExp = new RegExp(/^\d*\.?\d{0,100}$/g);
  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', '-', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];
  floatCount:number=Number(localStorage.getItem('floatCount') =='' ? 0 : localStorage.getItem('floatCount'));
  //floatCount:number=2;
  constructor(private el: ElementRef) {
  }
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    let current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [current.slice(0, position), event.key == 'Decimal' ? '.' : event.key, current.slice(position)].join('');
 
    if(next.split('.').length>this.floatCount && this.floatCount > 1){
        event.preventDefault();
      }
     else if(next.indexOf('.',0)!=-1 && next.length-next.indexOf('.',0)-1>this.floatCount){
        event.preventDefault();
      } 
    else if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }
}
